<template>
  <div class="commutator-chart">
    <default-chart
      x-data-manager="dateTime"
      chart-id="commutator-temperature-differential"
      :chart-data="chartData"
      :loading="loadingChart"
      :remove-outlier.sync="removeChartOutlier"
      :enable-multi-axis.sync="enableChartMultiAxis"
      @toggle-outlier="getChartData"
      @toggle-multi-axis="getChartData"
    />
  </div>
</template>

<script>
import DefaultChart from '@/components/charts/DefaultChart';
import defaultChartMixin from '@/domain/mixins/defaultChartMixin';
import Service from '@/domain/services/installation/engineering/commutatorTemperatureDifferential/commutatorTemperatureDifferentialService';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';

export default {
  name: 'CommutatorTemperatureChartTab',
  components: {
    DefaultChart,
  },
  mixins: [
    defaultChartMixin,
  ],
  data: () => ({
    chartData: [],
  }),
  created() {
    this.getChartData();
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getChartData() {
      this.loadingChart = true;
      return Service.getChart(this.$route.params.assetModuleId, this.chartFilters)
        .then((response) => {
          this.chartData = response;
        }).finally(() => {
          this.loadingChart = false;
        });
    },
    initListener() {
      eventBus.on(events.refreshDataTab, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshDataTab, this.refreshDataEvent, this);
    },
    refreshDataEvent() {
      this.getChartData();
    },
  },
};
</script>

<style lang="sass" scoped>
.commutator-chart
  ::v-deep .e-chart
    overflow: hidden
</style>
